<template>
    <div class="doc">
        <el-image :lazy="true" class="doc-img" :src="img" fit="contain">
            <template #error>
                <div></div>
            </template>
        </el-image>
        <div class="doc-footer">{{ duration }}</div>
    </div>
</template>

<script>
import moment from '@plugins/_moment';
export default {
    name: 'Doc',
    props: {
        img: {
            type: String,
            requried: true
        },
        time: {
            type: Number,
            required: true
        }
    },
    computed: {
        duration() {
            const { time } = this;
            if (time === -1) {
                return '00:00:00';
            }
            const duration = moment.duration(time * 1000);
            const hour = ('0' + duration.hours()).substr(-2);
            const minute = ('0' + duration.minutes()).substr(-2);
            const second = ('0' + duration.seconds()).substr(-2);
            return `${hour}:${minute}:${second}`;
        }
    }
};
</script>

<style lang="scss" scoped>
.doc {
    width: 114px;
    position: relative;
    &-img {
        width: 114px;
        height: 64px;
        display: block;
        background-color: #ffffff;
    }
    &-footer {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 20px;
        text-align: right;
        color: #ffffff;
        background-color: #333335;
        opacity: 0.73;
        padding: 0 4px;
        line-height: 20px;
    }
}
</style>
